import axios from 'axios'

const baseURL = process.env.VUE_APP_DROP_ORDER_SERVICE + '/api/admin/comments'

export default {
  namespaced: true,
  state: {
    is_loading: null,
    is_processing: null,
    dropComments: [],
    pagination: {
      last_page: 1
    }
  },
  mutations: {
    setDropComments (state, payload) {
      state.dropComments = payload
    },
    setPagination (state, payload) {
      state.pagination = payload
    }
  },
  actions: {
    async getDropComments ({ commit, state }, params) {
      state.is_loading = true
      const promise = axios.get(baseURL, {
        params: params
      })

      promise.then(response => {
        commit('setDropComments', response.data.data)
        commit('setPagination', { last_page: response.data.last_page })
        state.is_loading = false
      })
    },
    async createDropComment ({ commit, state }, data) {
      state.is_processing = true
      const promise = axios.post(baseURL, data)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async updateDropComment ({ commit, state }, data) {
      state.is_processing = true
      const promise = axios.put(baseURL + '/' + data.id, data)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async deleteDropComment ({ commit, state }, id) {
      state.is_processing = true
      const promise = axios.delete(baseURL + '/' + id)

      promise.then(() => {
        state.is_processing = false
        commit('removeDropCommentItem', id)
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    }
  }
}
